import { FormBuilderRef } from '@tn/formbuilder/hooks/useFormBuilder';
import {
    AnyEventObject,
    AnyStateConfig,
    assertEvent,
    DoneActorEvent,
    enqueueActions,
    ErrorActorEvent,
    Mapper,
    setup,
} from 'xstate';

import { flowRoutes, StateTypes } from '../../consts';
import { FlowEntity, InitMachineParams } from '../../types';
import { directFlowContext } from '../direct';
import { getUserGuards } from '../helpers';

export type icFlowContext = {
    formBuilderRef: FormBuilderRef | null;
    url: string;
    userPlan: string;
    couponCode: string;
};

export const invalidCouponFlow: FlowEntity = {
    initActor: (rawParams) => {
        const { config, actors, router, getConfigByKey, queryClient } =
            rawParams as InitMachineParams;

        return setup({
            types: {
                events: {} as
                    | { type: 'REDIRECT_USER' }
                    | {
                          type: 'CONNECT_FORMBUILDER_REF';
                          params: FormBuilderRef;
                      }
                    | DoneActorEvent<icFlowContext, 'invalidCoupon'>
                    | ErrorActorEvent<icFlowContext, 'invalidCoupon'>,
            },
            guards: {
                ...getUserGuards(queryClient),
            },
            actions: {
                assignFormBuilderRef: enqueueActions(({ enqueue, event }) => {
                    assertEvent(event, 'CONNECT_FORMBUILDER_REF');
                    enqueue.assign({ formBuilderRef: event.params });
                }),
                redirectUser: enqueueActions(({ enqueue, check, event }) => {
                    assertEvent(event, ['REDIRECT_USER', 'xstate.done.actor.invalidCoupon']);
                    const href =
                        check({ type: 'isExSubscriber' }) || check({ type: 'isRegistered' })
                            ? flowRoutes[StateTypes.pickplan]
                            : flowRoutes[StateTypes.account];
                    window.location.href = href;
                }),
            },
            actors,
        }).createMachine({ ...(config as AnyStateConfig) });
    },

    inputActor: <
        Mapper<
            directFlowContext,
            AnyEventObject,
            Pick<directFlowContext, 'couponCode'>,
            AnyEventObject
        >
    >(({ context }) => {
        return { couponCode: context.couponCode };
    }),
};
